import React from "react";
import PropTypes from "prop-types";
import styles from "./styles/SpinnerCustom.module.css";
import clsx from "clsx";
import { Spinner } from "react-bootstrap";

const SpinnerCustom = (props) => {
  const { className } = props;

  return (
    <div
      className={clsx(
        "d-flex gap-2 justify-content-center mt-2",
        styles.spinnerContainer,
        className
      )}
    >
      <Spinner
        as="span"
        animation="grow"
        size="sm"
        role="status"
        aria-hidden="true"
      />
      <Spinner
        as="span"
        animation="grow"
        size="sm"
        role="status"
        aria-hidden="true"
      />
      <Spinner
        as="span"
        animation="grow"
        size="sm"
        role="status"
        aria-hidden="true"
      />
    </div>
  );
};

/* required: display name */
SpinnerCustom.displayName = "SpinnerCustom";

/* required: props types */
SpinnerCustom.propTypes = { className: PropTypes.string };

/* required: default props */
SpinnerCustom.defaultProps = {};

export { SpinnerCustom };
